<template>
  <div class="extension detail">
    <header class="detail__header">
      <router-link
        :to="{ name: gridName }"
        class="btn-back"
      >
        <font-awesome-icon icon="chevron-left" />
      </router-link>
      <h1 v-if="object._id">
        {{ object.label }}
        <span
          v-if="deploying"
          class="text-primary"
        >
          <font-awesome-icon
            icon="spinner"
            spin
          />
        </span>
      </h1>
      <button
        @click="save"
        class="btn btn-success btn--save"
      >
        {{ $t('general.update') }}
      </button>
    </header>

    <div class="extension__form">
      <div class="panel">
        <div class="panel__body">
          <extension-form
            :fields="fields"
            :object="object"
          ></extension-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtensionForm from './form';
import { mapState } from 'vuex';
import { EventBus } from '@/event-bus.js';
import User from '@/store/models/User';

export default {
  name: 'objects-id',
  components: {
    ExtensionForm,
  },
  computed: {
    objectType() {
      return this.$route.params.type;
    },
    fields() {
      /* eslint-disable */
      return this.$store.getters['fields/getTypeFields'](this.objectType);
      /* eslint-enable */
    },
    ...mapState({
      entries: state => state.objects.entries,
    }),
    gridName() {
      return `${this.entity}-type-index`;
    },
  },
  data() {
    return {
      object: {},
      entity: 'objects',
      deploying: false,
    };
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.entity}/update`, {
        object: {
          _id: this.object._id,
          body: JSON.parse(JSON.stringify(this.object)),
          object_type: this.objectType,
        },
        callback: () => {
          this.$success(this.$t('general.messages.update.success'));
        },
      });
    },
    getFilekeys() {
      const filekeys = [];
      if (this.object) {
        Object.keys(this.object).forEach(key => {
          const value = this.object[key];
          if (value.lastModified) {
            filekeys.push(key);
          }
        });
      }
      return filekeys;
    },
    save() {
      // List all keys containing files
      const filekeys = this.getFilekeys();

      // There are no files - submit as is
      if (filekeys.length === 0) {
        this.submit();
      }

      let uploaded = 0;
      filekeys.forEach(key => {
        const value = this.object[key];
        // Value is file, upload it and change the value for link
        const formData = new FormData();
        formData.append('file', value);
        formData.append('filepath', `assets/pdf/${value.name}`);

        this.$http
          .post('/filesystem/upload', formData, {
            headers: {
              accept: 'application/json',
              'Accept-Language': 'en-US,en;q=0.8',
              'Content-Type': `multipart/form-data; boundary=${
                formData._boundary
              }`,
            },
          })
          .then(data => {
            this.object[key] = data.data;
            uploaded = uploaded + 1;

            // All files were uploaded, submit
            if (uploaded === filekeys.length) {
              this.submit();
            }
          });
      });
    },
    createWpUser(user, website, callback) {
      const requestUrl = `https://${website.dev_domain}/wp-json/wp/v2/users`;
      this.$info(`Create user operation for ${website.dev_domain} initiated`);
      const client = this.$http.create({
        headers: {
          Authorization:
            'Basic Y29udHJvbHVzZXI6dEJ3VSBsa05IIHdOcm0gWTlrcCBwUGoyIE1MN0c=',
        },
      });

      client
        .post(requestUrl, {
          username: user.username,
          email: user.email,
          password: user.password,
          locale: 'cs_CZ',
          roles: ['administrator'],
        })
        .then(data => {
          this.$success(
            `Create user operation for ${
              website.dev_domain
            } succesfully finished`,
          );
          if (typeof callback === 'function') {
            callback(data);
          }
        })
        .catch(error => {
          this.$error(
            `Create user operation for ${website.dev_domain} failed due to ${
              error.code
            } ${error.text}`,
          );
        });
    },
    minicpusers(users) {
      const user = users[0];
      this.minicpuser(user, () => {
        users.splice(0, 1);
        this.minicpusers(users);
      });
    },
    minicpuser(user, callback) {
      let callbackInitiated = false;
      this.findBy({
        object: 'objects',
        type: 'wordpress-user',
        field: 'user',
        id: user._id,
        callback: data => {
          callbackInitiated = true;
          this.createWpUser(data, this.object, callback);
        },
      });
      // @hotfix: ensure callback is called
      setTimeout(() => {
        if (!callbackInitiated && typeof callback === 'function') {
          callback();
        }
      }, 10000);
    },
  },
  created() {
    this.$store.dispatch('objects/get');
    this.$store.dispatch('fields/get');

    // Just saved
    if (this.$route.query.saved) {
      this.deploying = true;
    }

    EventBus.$on('objects/website/deploying', deploying => {
      this.deploying = deploying;
      // Create users
      if (this.$route.query.saved && deploying === false) {
        User.$get({}).then(data => {
          // data => data.forEach(user => this.minicpuser(user))
          this.minicpusers(data);
        });
      }
    });
  },
  watch: {
    entries(value) {
      if (value.length === 0) {
        return true;
      }
      const found = value.find(({ _id }) => _id === this.$route.params.id);
      if (typeof found !== 'undefined') {
        this.object = JSON.parse(JSON.stringify(found));
      }
    },
  },
};
</script>
